import { Component, Input } from '@angular/core';

import { CaArea, CaGroup } from '../../../core';

@Component({
    selector: 'cmps-ca-evaluation-result-focus',
    templateUrl: './focus.component.html',
})
export class FocusComponent {
    @Input()
    group: CaGroup;

    @Input()
    area: CaArea;
}
